// src/pages/Login.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const auth = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  // se già loggato, vai direttamente all'elenco
  useEffect(() => {
    if (auth?.user) navigate("/elenco", { replace: true });
  }, [auth?.user, navigate]);

  async function onSubmit(e) {
    e.preventDefault();
    if (busy) return;

    const em = String(email || "").trim();
    if (!em || !password) {
      alert("Inserisci email e password.");
      return;
    }

    try {
      setBusy(true);
      await auth.login(em, password);   // <-- CHIAMA IL CONTEXT
      navigate("/elenco", { replace: true }); // <-- ENTRA NELL'APP
    } catch (err) {
      const msg = err?.message || "Credenziali non valide";
      alert(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-page" style={{ display: "grid", placeItems: "center", minHeight: "100vh" }}>
      <form
        onSubmit={onSubmit}
        style={{
          width: 360, background: "#fff", padding: 24, borderRadius: 12,
          boxShadow: "0 10px 30px rgba(0,0,0,.12)"
        }}
        autoComplete="on"
      >
        <h2 style={{ marginTop: 0, marginBottom: 16 }}>Login Rilevatore</h2>

        <label style={{ fontSize: 12, color: "#666" }}>Email</label>
        <input
          type="email"
          inputMode="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={fieldStyle}
        />

        <label style={{ fontSize: 12, color: "#666" }}>Password</label>
        <input
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={fieldStyle}
        />

        <button
          type="submit"
          disabled={busy}
          style={{
            width: "100%", height: 44, marginTop: 12, border: 0,
            borderRadius: 8, background: busy ? "#bbb" : "linear-gradient(180deg,#e94c45,#c52720)",
            color: "#fff", fontWeight: 700, cursor: busy ? "default" : "pointer"
          }}
        >
          {busy ? "Accesso..." : "Accedi"}
        </button>
      </form>
    </div>
  );
}

const fieldStyle = {
  display: "block",
  width: "100%",
  height: 40,
  margin: "6px 0 14px",
  padding: "0 12px",
  borderRadius: 8,
  border: "1px solid #ddd",
  background: "#f7f9fc",
  outline: "none",
};
